<template>
    <div class="engineer-info">
        <a class="engineer-info__avatar" :href="profilePageUrl">
            <img class="engineer-info__avatar-img" :src="avatarUrl">
        </a>
        <div class="engineer-info__name">
            <a class="engineer-info__name-anchor" :href="profilePageUrl">
                {{name}}
            </a>
        </div>
        <div class="engineer-info__stats">
            {{stats}}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'EngineerInfo',
        props: {
            id: Number,
            name: String,
            profilePageUrl: String,
            avatarUrl: String,
            followersCount: Number,
            modelsCount: Number,
            tutorialsCount: Number,
        },
        data() {
            return {
                mutableFollowersCount: this.followersCount
            };
        },
        computed: {
            stats() {
                let result = [];
                if (this.mutableFollowersCount > 0) {
                    result.push(`${this.mutableFollowersCount} ${this.$pluralize('Follower', this.mutableFollowersCount)}`)
                }
                if (this.modelsCount > 0) {
                    result.push(`${this.modelsCount} ${this.$pluralize('Model', this.modelsCount)}`)
                }
                if (this.tutorialsCount > 0) {
                    result.push(`${this.tutorialsCount} ${this.$pluralize('Tutorial', this.tutorialsCount)}`)
                }
                return result.length ? result.join(', ') : '\xa0';
            }
        },
        methods: {
            setCount: function ({followable_id, count}) {
                if (followable_id === this.id) {
                    this.mutableFollowersCount = count;
                }
            }
        },
        mounted() {
            this.$eventHub.$on('followEvent', this.setCount);
        }
    }
</script>

<style lang="scss" scoped>
    .engineer-info {
        &__name {

            text-align: center;
            margin-top: 10px;

            &-anchor {
                color: $black;
                font-style: normal;
                font-weight: bold;
                font-size: $dashboard-font-size-medium-title;
                line-height: 12px;
            }
        }

        &__stats {
            text-align: center;
            color: $black;
            font-style: normal;
            font-weight: normal;
            font-size: $font-small;
            line-height: 12px;
            margin-top: 5px;
        }

        &__avatar {
            border: 2px solid #FFFFFF;
            border-radius: 50%;
            overflow: hidden;
            display: block;
            width: 50px;
            height: 50px;
            margin-top: -35px;
            position: relative;
            margin-left: auto;
            margin-right: auto;

            &-img {
                max-width: 100%;
            }
        }

    }
</style>
